import { ICompany } from "core/types/entities";
import { IVendor } from "core/types/entities/IVendor";
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type TDataState from "./type";

const initialState: TDataState = {
  currentCompany: null,
  currentVendor: null,
  companyActiveTab: null,
};

export const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setCurrentCompany: (state: TDataState, action: PayloadAction<ICompany>) => {
      state.currentCompany = action.payload;
    },
    setCurrentVendor: (state: TDataState, action: PayloadAction<IVendor>) => {
      state.currentVendor = action.payload;
    },
    setCompanyActiveTab: (state: TDataState, action: PayloadAction<string | null>) => {
      state.companyActiveTab = action.payload;
    },
  },
});

// Actions
export const { setCurrentCompany } = dataSlice.actions;
export const { setCurrentVendor } = dataSlice.actions;
export const { setCompanyActiveTab } = dataSlice.actions;

export default dataSlice.reducer;
